import { useQuery } from '@tanstack/react-query'

import { publicChatSession } from '@/ports'
import { FetchResponse } from '@/ports/api'

type PublicChatSession = {
  first_name?: string
  last_name?: string
  username?: string
}

function usePublicChatSession() {
  const { data, isLoading } = useQuery(
    [`usePublicChatSession`],
    () => publicChatSession() as Promise<FetchResponse<PublicChatSession>>,
    {
      staleTime: 0,
      cacheTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: 1,
      retryOnMount: false,
      select: ({ response, body }) => {
        if (response.ok) {
          return {
            first_name: body?.first_name,
            last_name: body?.last_name,
            email: body?.username
          }
        }
        return null
      },
      onError: () => {
        return
      }
    }
  )

  return { data, isLoading }
}

export default usePublicChatSession
